import { FilterData } from "src/components/transactions/types";

export const formatTableTitle = (title: string) => {
  if (title === "fiatTransactions") return "Fiat Transactions";
  if (title === "orders") return "Trades";
  if (title === "cryptoWithdrawals") return "Crypto Withdrawals";
  if (title === "cryptoDeposits") return "Crypto Deposits";
  if (title === "otherTransactions") return "Other Transactions";
  return title.charAt(0).toUpperCase() + title.slice(1);
};
export const formatTableHeader = (titleArray: string[]) => {
  return titleArray.map((el) => {
    // Some titles needs to be replace, while others only needs to be capitalized
    if (el === "price") return "Price";
    if (el === "value") return "Value";
    if (el === "quoteCurrency") return "Currency";
    if (el === "totalValue") return "Total";
    return el.charAt(0).toUpperCase() + el.slice(1);
  });
};

export const disclaimerMessage =
  "Disclaimer:\n\nYou understand and acknowledge that the content of this document reflects order(s) placed \nand transaction(s) executed by you and is solely provided for your own general information. \nThis document does not constitute any financial, investment, legal, tax or any other advice. \nThis document is available to you on an ‘as-is’ basis only, and Caleb & Brown \nis not liable for your amendment(s) to this document after export. \n\nPlease contact us at support@calebandbrown.com if you require a summary older than Aug 2020. \n\nNote that, only completed transactions will be included in the report.";

export const initialFilterData: FilterData = {
  txType: "all",
  currency: "",
  device: "desktop",
  startTxSize: undefined,
  endTxSize: undefined,
  startDate: undefined,
  endDate: undefined,
};
